export enum SideNavIdsEnum {
  openCloseBtn = 'sidenavOpenCloseBtn'
};

export enum SideNavAnimationStatesEnum {
  open = 'open',
  close = 'close'
};
